module.exports = __webpack_public_path__ + "static/media/popup-video.ff5acde4.jpg";